import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	Row,
	Col,
	Nav,
	NavItem,
	NavLink,
	TabContent,
} from "reactstrap";
import classnames from "classnames";

import { connect } from "react-redux";

import SRFiltersRightbar from "../SRFiltersRightbar";
import AllPurchase from "./AllPurchase";
import "../PurchaseIndent.scss";

import {
	getMySR_PIReqList,
	SetParams,
	FilterChangeValue,
	FilterSelecteChangeValue,
	getMySR_PIListcount,
	FiltersShowRightSidebar,
	FilterClear,
} from "../../../store/SRPurchaseIndent/actions";
import LoadingModel from "../../LoadingModel";

class MyPurchaseIndent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: "1",
			currentPage: 1,
			FilterToggle: false,
		};
		this.toggleTab = this.toggleTab.bind(this);
	}

	toggleTab(tab) {
		var sistatus = [0];
		if (tab === 1) {
			sistatus = [0];
		} else if (tab !== 2) {
			sistatus = [tab];
		} else if (tab === 2) {
			sistatus = [1, 2];
		}
		this.props.SetParams({
			...this.props.params,
			sistatus: sistatus,
			page: 1,
			// start_date: "",
			// end_date: "",
		});
		this.props.getMySR_PIReqList({
			...this.props.params,
			sistatus: sistatus,
			page: 1,
			// start_date: "",
			// end_date: "",
		});
	}
	componentDidMount() {
		this.props.FilterClear();

		this.props.getMySR_PIListcount();
		this.props.SetParams({
			...this.props.params,
			sistatus: [0],
			search: "",
			start_date: "",
			end_date: "",
			userdepartment: "",
			department: "",
			siitems__product: "",
		});
		this.props.getMySR_PIReqList({
			...this.props.params,
			sistatus: [0],
			search: "",
			start_date: "",
			end_date: "",
			userdepartment: "",
			department: "",
			siitems__product: "",
		});
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content ">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}
						<Row>
							<Col lg={12}>
								<Card className="pagebody">
									<CardHeader className="bg-transparent pb-0">
										<h5 className="card-title-18 pt-2 d-inline-block">
											Service Indent Dashboard
										</h5>
										<div className="float-right">
											<div className="d-inline-block">
												<Button
													type="button"
													color="light"
													className="waves-effect waves-light d-flex  mr-2"
													onClick={() =>
														this.props.FiltersShowRightSidebar(
															1
														)
													}>
													<i className="mdi mdi-filter"></i>
													<span className="d-none d-lg-bl ock ml-1">
														Filters
													</span>
												</Button>
											</div>

											<Button
												type="button"
												color="primary"
												className="waves-effect waves-light"
												href="/newsrpirequest/0">
												New Service Indent
											</Button>
										</div>
									</CardHeader>
									<CardBody className="pt-0">
										<Nav tabs className="nav-tabs-custom ">
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(1);
													}}
													className={classnames(
														{
															active:
																this.props
																	?.params
																	?.sistatus[0] ===
																0,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													All |{" "}
													<span>
														{
															this.props
																.PIListCount
																?.all_count
														}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(2);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.sistatus[0] ===
																1,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													Pending |{" "}
													<span>
														{
															this.props
																.PIListCount
																?.pending_count
														}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(3);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.sistatus[0] ===
																3,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													Approved |{" "}
													<span>
														{
															this.props
																.PIListCount
																?.approved_count
														}
													</span>
												</NavLink>
											</NavItem>
											<NavItem>
												<NavLink
													onClick={() => {
														this.toggleTab(4);
													}}
													className={classnames(
														{
															active:
																this.props
																	.params
																	.sistatus[0] ===
																4,
														},
														"pt-3 font-weight-bold card-title-16"
													)}>
													Rejected |{" "}
													<span>
														{
															this.props
																.PIListCount
																?.rejected_count
														}
													</span>
												</NavLink>
											</NavItem>
										</Nav>
										<TabContent>
											<AllPurchase />
										</TabContent>
									</CardBody>
								</Card>
							</Col>
						</Row>
						<SRFiltersRightbar />
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		PIRowList,
		params,
		PIRowListCount,
		PIListModel,
		PIListCount,
		loading,
	} = state.SRpurchaseIndent;
	return {
		PIRowList,
		PIRowListCount,
		PIListModel,
		PIListCount,
		params,
		loading,
	};
};

export default connect(mapStatetoProps, {
	getMySR_PIReqList,
	FilterChangeValue,
	FilterSelecteChangeValue,
	SetParams,
	getMySR_PIListcount,
	FiltersShowRightSidebar,
	FilterClear,
})(MyPurchaseIndent);
